export const LS_ONBOARDING_V1_KEY = 'lsonboardingV1';
export const LS_NEW_CHAR_KEY = 'lsnewchar';
export const LS_DISCOUNT_TIMER_KEY = 'lsdisctimer';
export const LS_SIGNOUT_DATE_KEY = 'lssignodate';
export const LS_MSG_DRAFTS_KEY = 'lsmdrafts';
export const LS_ENDORSELY_AFFILIATE_REF_KEY = 'lsndlyaffref';
export const LS_OFFLINE_REFRESH_TSTMP_KEY = 'lsoffrefreshtstmp';
export const LS_TTS_VOICE_SELECTION_SHOWN_KEY = 'lsttsvoiceselecshown';

export const SESSION_IS_STANDALONE_MODE_KEY = 'lsisstandalone';
export const SESSION_HAS_ANDROID_TWA_REFERRER_KEY = 'lshasandroidtwaref';
export const SESSION_HAS_PLAYSTORE_TWA_HASH_KEY = 'lshaspstoretwahash';
export const SESSION_HAS_IOS_APP_REFERRER_KEY = 'lshasiosappref';
export const SESSION_HAS_IOS_APP_HASH_KEY = 'lshasiosapphash';

export const MAX_UI_MESSAGES = 500;

export const COST_PER_VIDEO = 10;
export const COST_PER_IMAGE = 2;

// Supported languages for TTS
export const SUPPORTED_TTS_LANGUAGES = ['fr', 'zh', 'hi', 'ja', 'pt', 'es', 'en'];
export type SupportedTTSLanguage = typeof SUPPORTED_TTS_LANGUAGES[number];

/**
 * Find the best voice for a given language
 * @param language - The language code (e.g., 'fr', 'zh', 'en')
 * @param gender - The gender preference ('f' or 'm')
 * @returns The voice value or undefined if no suitable voice found
 */
export function findBestVoiceForLanguage(language: string, gender: 'f' | 'm'): string | undefined {
  return VOICE_OPTIONS.find(voice => 
    voice.languages?.includes(language) && 
    ((voice.fOnly && gender === 'f') || (voice.mOnly && gender === 'm') || (!voice.fOnly && !voice.mOnly))
  )?.value;
}

export const TWA_PACKAGE_NAME = 'ai.eveninghoney.www.t';
export const TWA_START_URL_HASH = '#playstore-twa';
export const PLAY_BILLING_SERVICE_ID = 'https://play.google.com/billing';

export const IOS_START_URL_HASH = '#ios';
export const IOS_APP_STORE_ID = '6749209857';
export const IOS_BUNDLE_ID = 'ai.eveninghoney.www';

// CHARACTER CREATION OPTIONS

export type OptionsType = {
  value: string,
  label: string,
  imgPath?: string,
  mImgPath?: string,
  locked?: boolean,
  isDefault?: boolean,
  fOnly?: boolean,
  mOnly?: boolean,
  icon?: string,
  notSafeForStores?: boolean,
  // Relationship / personality options
  emoji?: string,
  desc?: string,
  // Language support for TTS
  languages?: string[],
};

export const GENDER_OPTIONS: OptionsType[] = [
  { value: 'f', label: 'Female', icon: '♀️', isDefault: true },
  { value: 'm', label: 'Male', icon: '♂️', locked: false },
];
export const STYLE_OPTIONS: OptionsType[] = [
  { value: 'realistic', label: 'Realistic', imgPath: 'f/eh-cr-f-real.webp', mImgPath: 'm/eh-cr-m-real.webp', isDefault: true },
  { value: 'anime', label: 'Anime', imgPath: 'f/eh-cr-f-anime.webp', mImgPath: 'm/eh-cr-m-anime.webp', locked: false },
];

export const ETHNICITY_OPTIONS: OptionsType[] = [
  { value: 'caucasian', label: 'Caucasian', imgPath: 'f/eh-cr-f-ethn-caucasian-2.webp', mImgPath: 'm/eh-cr-m-ethn-caucasian.webp' },
  { value: 'hispanic', label: 'Hispanic', imgPath: 'f/eh-cr-f-ethn-hispanic.webp', mImgPath: 'm/eh-cr-m-ethn-hispanic.webp' },
  { value: 'east_asian', label: 'East Asian', imgPath: 'f/eh-cr-f-ethn-asian.webp', mImgPath: 'm/eh-cr-m-ethn-asian.webp' },
  { value: 'indian', label: 'Indian', imgPath: 'f/eh-cr-f-ethn-indian.webp', mImgPath: 'm/eh-cr-m-ethn-indian.webp', locked: true },
  { value: 'middle_eastern', label: 'Middle Eastern', imgPath: 'f/eh-cr-f-ethn-middle-eastern.webp', mImgPath: 'm/eh-cr-m-ethn-middle-eastern.webp', locked: true },
  { value: 'black', label: 'Black', imgPath: 'f/eh-cr-f-ethn-black.webp', mImgPath: 'm/eh-cr-m-ethn-black.webp', locked: true },
  { value: 'mixed', label: 'Mixed', imgPath: 'f/eh-cr-f-ethn-mixed.webp', mImgPath: 'm/eh-cr-m-ethn-mixed.webp', locked: true },
  { value: 'random', label: 'Random', imgPath: 'eh-cr-random-8ball.webp', mImgPath: 'eh-cr-random-8ball.webp',   isDefault: true },
];
export const AGE_OPTIONS: OptionsType[] = [
  { value: '18', label: 'Teen (18+)', locked: true },
  { value: '20s', label: '20s', isDefault: true },
  { value: '30s', label: '30s' },
  { value: '40s', label: '40s', locked: true },
  { value: '50s', label: '50s', locked: true },
  { value: '60+', label: '60+', locked: true },
];

export const EYE_COLOR_OPTIONS: OptionsType[] = [
  { value: 'brown', label: 'Brown', imgPath: 'f/eh-cr-f-eyes-brown.webp', mImgPath: 'm/eh-cr-m-eyes-brown.webp', isDefault: true },
  { value: 'blue', label: 'Blue', imgPath: 'f/eh-cr-f-eyes-blue.webp', mImgPath: 'm/eh-cr-m-eyes-blue.webp' },
  { value: 'green', label: 'Green', imgPath: 'f/eh-cr-f-eyes-green.webp', mImgPath: 'm/eh-cr-m-eyes-green.webp', locked: true },
  { value: 'hazel', label: 'Hazel', imgPath: 'f/eh-cr-f-eyes-hazel.webp', mImgPath: 'm/eh-cr-m-eyes-hazel.webp', locked: true },
];
export const HAIR_STYLE_OPTIONS: OptionsType[] = [
  { value: 'straight', label: 'Straight', imgPath: 'f/eh-cr-f-hair-straight.webp', fOnly: true },
  { value: 'fade', label: 'Fade', mImgPath: 'm/eh-cr-m-hair-fade.webp', locked: true, mOnly: true },
  { value: 'braids', label: 'Braids', imgPath: 'f/eh-cr-f-hair-braids.webp', locked: true, fOnly: true },
  { value: 'bangs', label: 'Bangs', imgPath: 'f/eh-cr-f-hair-bangs.webp', locked: true, fOnly: true },
  { value: 'short', label: 'Short', imgPath: 'f/eh-cr-f-hair-short.webp', mImgPath: 'm/eh-cr-m-hair-short.webp' },
  { value: 'long', label: 'Long', imgPath: 'f/eh-cr-f-hair-long.webp', mImgPath: 'm/eh-cr-m-hair-long-2.webp', isDefault: true },
  { value: 'curly', label: 'Curly', imgPath: 'f/eh-cr-f-hair-curly.webp', mImgPath: 'm/eh-cr-m-hair-curly.webp', locked: true, fOnly: true },
  { value: 'wavy', label: 'Wavy', imgPath: 'f/eh-cr-f-hair-wavy.webp', fOnly: true },
  { value: 'bun', label: 'Bun', imgPath: 'f/eh-cr-f-hair-bun.webp', locked: true, fOnly: true },
  { value: 'ponytail', label: 'Ponytail', imgPath: 'f/eh-cr-f-hair-ponytail.webp', locked: true, fOnly: true },
  { value: 'pigtails', label: 'Pigtails', imgPath: 'f/eh-cr-f-hair-pigtails.webp', locked: true, fOnly: true },
  { value: 'bald', label: 'Bald', mImgPath: 'm/eh-cr-m-hair-bald.webp', locked: true, mOnly: true },
];
export const HAIR_COLOR_OPTIONS: OptionsType[] = [
  { value: 'blonde', label: 'Blonde', imgPath: 'f/eh-cr-f-hair-color-blonde.webp', mImgPath: 'm/eh-cr-m-hair-color-blonde.webp' },
  { value: 'brunette', label: 'Brunette', imgPath: 'f/eh-cr-f-hair-color-brunette.webp', mImgPath: 'm/eh-cr-m-hair-color-brunette.webp' },
  { value: 'black', label: 'Black', imgPath: 'f/eh-cr-f-hair-color-black.webp', mImgPath: 'm/eh-cr-m-hair-color-black.webp', isDefault: true },
  { value: 'red', label: 'Red', imgPath: 'f/eh-cr-f-hair-color-red.webp', mImgPath: 'm/eh-cr-m-hair-color-red.webp', locked: true },
  { value: 'pink', label: 'Pink', imgPath: 'f/eh-cr-f-hair-color-pink.webp', locked: true, fOnly: true },
  { value: 'gray', label: 'Gray', imgPath: 'f/eh-cr-f-hair-color-gray.webp', mImgPath: 'm/eh-cr-m-hair-color-gray.webp', locked: true },
];

export const BODY_TYPE_OPTIONS: OptionsType[] = [
  { value: 'slim', label: 'Slim', imgPath: 'f/eh-cr-f-body-slim.webp', mImgPath: 'm/eh-cr-m-body-slim.webp', locked: true, fOnly: true },
  { value: 'athletic', label: 'Athletic', imgPath: 'f/eh-cr-f-body-athletic.webp', mImgPath: 'm/eh-cr-m-body-athletic.webp' },
  { value: 'normal', label: 'Normal', imgPath: 'f/eh-cr-f-body-normal.webp', mImgPath: 'm/eh-cr-m-body-normal.webp', isDefault: true },
  { value: 'voluptuous', label: 'Voluptuous', imgPath: 'f/eh-cr-f-body-voluptuous.webp', locked: true, fOnly: true },
  { value: 'muscular', label: 'Muscular', mImgPath: 'm/eh-cr-m-body-muscular.webp', mOnly: true },
  { value: 'curvy', label: 'Curvy', imgPath: 'f/eh-cr-f-body-curvy.webp', locked: true, fOnly: true },
  { value: 'plump', label: 'Plump', mImgPath: 'm/eh-cr-m-body-plump.webp', locked: true, mOnly: true },
];
export const BUST_SIZE_OPTIONS: OptionsType[] = [
  { value: 'small', label: 'Small', imgPath: 'f/eh-cr-f-bust-small.webp', locked: true },
  { value: 'medium', label: 'Medium', imgPath: 'f/eh-cr-f-bust-medium.webp', isDefault: true },
  { value: 'big', label: 'Big', imgPath: 'f/eh-cr-f-bust-big.webp' },
  { value: 'huge', label: 'Huge', imgPath: 'f/eh-cr-f-bust-huge.webp', locked: true },
].map(opt => ({ ...opt, fOnly: true }));
export const BUTT_SIZE_OPTIONS: OptionsType[] = [
  { value: 'small', label: 'Small', imgPath: 'f/eh-cr-f-butt-small.webp', locked: true },
  { value: 'medium', label: 'Medium', imgPath: 'f/eh-cr-f-butt-medium.webp', isDefault: true },
  { value: 'large', label: 'Large', imgPath: 'f/eh-cr-f-butt-large.webp' },
  { value: 'huge', label: 'Huge', imgPath: 'f/eh-cr-f-butt-huge.webp', locked: true },
].map(opt => ({ ...opt, fOnly: true }));

export const PERSONALITY_OPTIONS: OptionsType[] = [
  { value: 'caregiver', label: 'Caregiver', emoji: '🫶', desc: 'Always there to offer some affection and comfort.' },
  { value: 'wise', label: 'Wise', emoji: '🧘‍♀️', desc: 'A source of wisdom.', locked: false },
  { value: 'ambitious', label: 'Ambitious', emoji: '🧗', desc: 'Loves challenges and always wants to be the best.' },
  { value: 'amusing', label: 'Amusing', emoji: '🤹', desc: 'Cheerful, funny, and always there to make you laugh.' },
  { value: 'seducer', label: 'Seducer', emoji: '💋', desc: 'Loves to seduce, tease and turn you on.', isDefault: true },
  { value: 'dominant', label: 'Dominant', emoji: '👑', desc: 'Wants to be in control.' },
  { value: 'submissive', label: 'Submissive', emoji: '🫡', desc: 'Happy to be lead by a strong partner.' },
  { value: 'romantic', label: 'Romantic', emoji: '💗', desc: 'Longs for a deep emotional connection and affection.' }, 
  { value: 'insatiable', label: 'Insatiable', emoji: '🔥', desc: 'Always looking for intimacy and passionate contact.' },
  { value: 'bully', label: 'Bully', emoji: '🥊', desc: 'Intimidating, often sarcastic and dismissive.' },
  { value: 'rebellious', label: 'Rebellious', emoji: '✊', desc: 'Disputes authority, loves like-minded people.' },
  { value: 'mysterious', label: 'Mysterious', emoji: '🔒', desc: 'Full of secrets and mysteries.' },
];
export const RELATIONSHIP_OPTIONS: OptionsType[] = [
  { value: 'stranger', label: 'Stranger', emoji: '👋' },
  { value: 'school mate', label: 'School Mate', emoji: '🎓' },
  { value: 'colleague', label: 'Colleague', emoji: '💼' },
  { value: 'mentor', label: 'Mentor', emoji: '📚' },
  { value: 'girlfriend', label: 'Girlfriend', emoji: '❤️', fOnly: true },
  { value: 'sex friend', label: 'Friends with Benefits', emoji: '⚤', notSafeForStores: true },
  { value: 'wife', label: 'Wife', emoji: '💍', fOnly: true, notSafeForStores: true },
  { value: 'mistress', label: 'Mistress', emoji: '👠', fOnly: true, notSafeForStores: true },
  { value: 'friend', label: 'Friend', emoji: '🤝', isDefault: true },
  { value: 'best friend', label: 'Best Friend', emoji: '🤗' },
  { value: 'step sister', label: 'Step Sister', emoji: '🛑', locked: false, fOnly: true },
  { value: 'step brother', label: 'Step Brother', emoji: '🛑', locked: false, mOnly: true },
  { value: 'step mom', label: 'Step Mom', emoji: '🔥', fOnly: true, notSafeForStores: true },
  { value: 'ex wife', label: 'Ex-Wife', emoji: '💔', fOnly: true },
  { value: 'ex girlfriend', label: 'Ex-Girlfriend', emoji: '❤️‍🩹', fOnly: true },
  { value: 'boyfriend', label: 'Boyfriend', emoji: '❤️', mOnly: true },
  { value: 'ex-husband', label: 'Ex-Husband', emoji: '💔', mOnly: true },
  { value: 'ex-boyfriend', label: 'Ex-Boyfriend', emoji: '❤️‍🩹', mOnly: true },
  { value: 'online connection', label: 'Online Connection', emoji: '🌐' },
  { value: 'long distance', label: 'Long Distance', emoji: '✈️' },
  { value: 'long-time crush', label: 'Long-time Crush', emoji: '😍' },
  { value: 'personal trainer', label: 'Personal Trainer', emoji: '🏋️' },
  { value: 'vacation fling', label: 'Vacation Fling', emoji: '🏖️' },
];

export const OCCUPATION_OPTIONS: OptionsType[] = [
  { value: 'fitness instructor', label: 'Fitness Instructor' },
  { value: 'dancer', label: 'Dancer' },
  { value: 'fashion model', label: 'Fashion Model', fOnly: true, isDefault: true },
  { value: 'actor', label: 'Actor', mOnly: true },
  { value: 'actress', label: 'Actress', fOnly: true },
  { value: 'stay-at-home', label: 'Stay-at-home' },
  { value: 'lawyer', label: 'Lawyer' },
  { value: 'musician', label: 'Musician' },
  { value: 'photographer', label: 'Photographer' },
  { value: 'flight attendant', label: 'Flight Attendant' },
  { value: 'student', label: 'Student' },
  { value: 'teacher', label: 'Teacher' },
  { value: 'cook', label: 'Cook' },
  { value: 'maid', label: 'Maid', fOnly: true },
  { value: 'construction_worker', label: 'Construction Worker' },
  { value: 'mechanic', label: 'Mechanic' },
  { value: 'police officer', label: 'Police Officer' },
  { value: 'nurse', label: 'Nurse', fOnly: true },
  { value: 'doctor', label: 'Doctor' },
  { value: 'influencer', label: 'Influencer' },
  { value: 'writer', label: 'Writer' },
  { value: 'blogger', label: 'Blogger' },
  { value: 'florist', label: 'Florist' },
  { value: 'pornstar', label: 'Pornstar', locked: true, notSafeForStores: true },
  { value: 'onlyfans model', label: 'OnlyFans Model', locked: true, fOnly: true, notSafeForStores: true },
  { value: 'librarian', label: 'Librarian' },
  { value: 'nun', label: 'Nun', fOnly: true },
  { value: 'spy', label: 'Spy' },
];
export const HOBBY_OPTIONS: OptionsType[] = [
  { value: 'dance', label: 'Dance' },
  { value: 'hiking', label: 'Hiking' },
  { value: 'tennis', label: 'Tennis' },
  { value: 'golfing', label: 'Golfing' },
  { value: 'cooking', label: 'Cooking' },
  { value: 'reading', label: 'Reading' },
  { value: 'martial arts', label: 'Martial Arts' },
  { value: 'yoga', label: 'Yoga', locked: false },
  { value: 'surfing', label: 'Surfing' },
  { value: 'photography', label: 'Photography' },
  { value: 'video games', label: 'Video Games' },
  { value: 'watching netflix', label: 'Watching Netflix' },
  { value: 'travel', label: 'Travel', isDefault: true },
  { value: 'anime', label: 'Anime' },
  { value: 'partying', label: 'Partying' },
  { value: 'social media', label: 'Social Media' },
  { value: 'wine tasting', label: 'Wine Tasting' },
  { value: 'weightlifting', label: 'Weightlifting' },
  { value: 'veganism', label: 'Veganism' },
];

export const OUTFIT_OPTIONS: OptionsType[] = [
  { value: 'bikini', label: 'Bikini', fOnly: true },
  { value: 'evening dress', label: 'Evening Dress', fOnly: true },
  { value: 'summer dress', label: 'Summer Dress', fOnly: true },
  { value: 'wedding dress', label: 'Wedding Dress', fOnly: true },
  { value: 'suit', label: 'Suit', mOnly: true },
  { value: 'cheerleader', label: 'Cheerleader', fOnly: true },
  { value: 'skirt', label: 'Skirt', fOnly: true },
  { value: 'swimsuit', label: 'Swimsuit' },
  { value: 'lab coat', label: 'Lab Coat' },
  { value: 'pyjamas', label: 'Pyjamas' },
  { value: 'carnival', label: 'Carnival' },
  { value: 'casual', label: 'Casual', isDefault: true },
  { value: 'flight attendant', label: 'Flight Attendant' },
  { value: 'corset', label: 'Corset', fOnly: true },
  { value: 'leggings', label: 'Leggings', fOnly: true },
  { value: 'yoga outfit', label: 'Yoga Outfit' },
  { value: 'lingerie', label: 'Lingerie', fOnly: true, notSafeForStores: true },
  { value: 'leather outfit', label: 'Leather Outfit' },
  { value: 'police', label: 'Police' },
  { value: 'steampunk', label: 'Steampunk' },
  { value: 'firefighter', label: 'Firefighter' },
  { value: 'military', label: 'Military' },
  { value: 'construction_worker', label: 'Construction Worker' },
  { value: 'belly dancer', label: 'Belly Dancer', locked: false, fOnly: true },
  { value: 'hiphop', label: 'Hiphop' },
  { value: 'hijab', label: 'Hijab', fOnly: true },
  { value: 'secretary', label: 'Secretary', fOnly: true },
];

export const VOICE_OPTIONS: (OptionsType & { languages: string[] })[] = [
  { value: 'f_k_american', label: 'American', fOnly: true, isDefault: true, languages: ['en'] },
  { value: 'f_k_american-asmr', label: 'American, ASMR', fOnly: true, languages: ['en'] },
  { value: 'f_k_american-casual', label: 'American, Casual', fOnly: true, locked: true, languages: ['en'] },
  { value: 'f_k_american-deep', label: 'American, Deep', fOnly: true, languages: ['en'] },
  { value: 'f_k_american-dynamic', label: 'American, Dynamic', fOnly: true, languages: ['en'] },
  { value: 'f_k_american-intimate', label: 'American, Intimate', fOnly: true, languages: ['en'] },
  { value: 'f_k_american-mature', label: 'American, Mature', fOnly: true, locked: true, languages: ['en'] },
  { value: 'f_k_american-sultry', label: 'American, Sultry', fOnly: true, locked: true, languages: ['en'] },
  { value: 'f_k_american-young', label: 'American, Young', fOnly: true, locked: true, languages: ['en'] },
  { value: 'f_k_british', label: 'British', fOnly: true, languages: ['en'] },
  { value: 'f_k_chinese', label: 'Chinese', fOnly: true, languages: ['zh'] },
  { value: 'f_k_french', label: 'French', fOnly: true, languages: ['fr','en'] },
  { value: 'f_k_hindi', label: 'Hindi', fOnly: true, languages: ['hi','en'] },
  { value: 'f_k_japanese', label: 'Japanese', fOnly: true, languages: ['ja'] },
  { value: 'f_k_portuguese', label: 'Portuguese', fOnly: true, locked: true, languages: ['pt'] },
  { value: 'f_k_spanish', label: 'Spanish', fOnly: true, languages: ['es'] },

  // Male voices
  { value: 'm_k_american', label: 'American', mOnly: true, isDefault: true, languages: ['en'] },
  { value: 'm_k_american-deep', label: 'American, Deep', mOnly: true, languages: ['en'] },
  { value: 'm_k_british', label: 'British', mOnly: true, languages: ['en'] },
  { value: 'm_k_chinese', label: 'Chinese', mOnly: true, languages: ['zh'] },
  { value: 'm_k_hindi', label: 'Hindi', mOnly: true, locked: true, languages: ['hi'] },
  { value: 'm_k_portuguese', label: 'Portuguese', mOnly: true, locked: true, languages: ['pt'] },
  { value: 'm_k_spanish', label: 'Spanish', mOnly: true, languages: ['es'] },
];

export const CHARACTER_SLUGS_NOT_SAFE_FOR_STORES = [
  'alexandra-roth-6drl',
  'sophie-chen-4j01',
  'sofia-reyes-x917',
  'sister-clarissa-7fwe',
  'jada-baker-5gl2',
  'carmen-rojas-feb4',
  'nahla-farouq-7uxe',
  'jasmine-carrington-jsnv',
  'aurora-weiss-tlgq',
  'elena-russo-e84d',
  'giorgia-rossi-7jlz',
  'scheherazade-qureshi-e845',
  // Anime
  'elise-voss-7vqs',
  'rosa-barranco-jdzz',
  'remy-beaumont-djhr',
  'nova-ryder-ap4c',
  'mei-ling-wong-m34p'
];
